
import {
    IKWFConnectionInfo, IKWFHubServer, IKWFClientState
} from "@common/rwfsignalrtypes";

import * as angular from 'angular';

import { fn } from '@common/utils';

import * as kutils from '../navkendo';
import * as rwf3 from '@common/rwf';
import { NavGridOptions } from '@common/navkendo/navgrid';
import { DialogService, IDialogState } from '@services/dialogservice';
import { KWFApplicationService } from "../KWFApplication";
import { INavPageInfo, NavPageAdminService } from '@common/navdata/navpageadminservice';
import { IPageMetaData, IPageProperty } from '../nav';
import resolveToError = fn.resolveToError;
import UISafe = fn.UISafe;

import { KWFAdminController } from '../adminconnections/adminconnections';
import { ViewAdminController } from './viewadmin.ctrl';
import { KWFJobQueueController } from './jobqueue.ctrl';
import { Model, Observable, ObservableArray, IObservableArray } from "@common/navdata/navmodel";
import { CompatibilityService } from "@common/services/compatibilityservice";

import { KWFAppUpdateController } from './appupdate.ctrl';
import { RwfAppSettings, IRwfApplicationSettings } from "@common/rwf/rwf.appsettings";
import { FDRW_WFInstance } from "@common/rwf/rwf.const";
/** Administrative App Functionality */
export class KWFAdminService {
    static $inject = ["CompatibilityService", "KWFApplication"];
    constructor(private $c: CompatibilityService, public KWFApplication: KWFApplicationService) { }

    /** Currently Connected Clients Info (excluding mySelf), imp Refreshed */
    Clients = kutils.AsObservableArray<IKWFConnectionInfo>([]);

    /** Register this Client to get Notified about De-/Re-, Connecting Clients */
    Register() {
        return this.KWFApplication.getKwfHub(true).then((hub) => {
            this.Hub = hub.server;
            return this.toQ(hub.server.registerAdmin()).then(c => this.MyRegisteredConnection = c);
        });
    }
    private MyRegisteredConnection: IKWFConnectionInfo;
    public Hub: IKWFHubServer;

    /** DeRegister this Client from getting Notifed about De-/Re-, Connecting Clients */
    DeRegister(myConnection: IKWFConnectionInfo) {
        return this.KWFApplication.getKwfHub(true).then((hub) => this.toQ(hub.server.deregisterAdmin(myConnection)));
    }

    /** Helper : Allows Validation of Administrative Access (to prevent later ALL Calls will fail!) */
    Validate() {
        return this.KWFApplication.getKwfHub(true).then(hub => {
            return this.toQ(hub.server.getConnectedClients()).then(() => this, err => {
                throw new Error("Der administrative Zugriff auf die Anwendung ist nicht möglich." + resolveToError(err));
            });
        });
    }

    /** Refresh Connected Clients Information from Server */
    public RefreshClients(force?: boolean) {
        if (!force && this.currentRefresh)
            return this.currentRefresh;

        var started = this.currentRefresh = UISafe(this.toQ(this.Hub.getConnectedClients()).then(clientsInfo => {
            if (started == this.currentRefresh) {
                clientsInfo.forEach(c => {
                    var state = c.CurrentClientState = c.CurrentClientState || <IKWFClientState><any>{};
                    state.Version = state.Version || { Version: "", PatchLevel: "" };

                    c.LastRefresh = fn.ToDate(c.LastRefresh);
                    c.Created = fn.ToDate(c.Created);
                    state.LastRouteChange = fn.ToDate(state.LastRouteChange);
                    state.StartUpTime = fn.ToDate(state.StartUpTime);
                });
                var clients = this.Clients;
                var myConnectionId = this.MyRegisteredConnection && this.MyRegisteredConnection.ConnectionID;

                if (myConnectionId) {
                    fn.RemoveIf(clientsInfo, c => c.ConnectionID == myConnectionId);
                }
                kutils.ReplaceObservableData(clients, clientsInfo, item => item.ConnectionID);
            }
            return clients;
        }));
        this.$c.finally(started, () => {
            if (started == this.currentRefresh) {
                delete this.currentRefresh;
            }
        });
        return started;
    }
    /** currently Running Clients Refresh Cycle */
    private currentRefresh: PromiseLike<IObservableArray<IKWFConnectionInfo>>;

    /** Force All Clients */
    public ForceClientsRefresh(forceClientsCheck: boolean) {
        var me = this;
        var clientsToRefresh = me.Clients.map(fn.identity);
        var singleRefreshCycle = () => me.RefreshClients().then(() => {
            // Remove Refreshed Clients
            me.Clients.forEach(client => fn.RemoveIf(clientsToRefresh, c => c.ConnectionID == client.ConnectionID));
            if (clientsToRefresh.length == 0)
                return true;
        });
        // ReQuery Server for Clients after Requesting all Clients to reSend their information util all Refreshed or timeout reached
        return me.toQ(me.Hub.requestClientState(forceClientsCheck)).then(() => me.WaitUntil(singleRefreshCycle, 4 * 3, 250)); // max 3 secs
    }

    /** Utility : JQeuryPromise2AngularPromise */
    toQ<T>(jQ: JQueryPromise<T>) {
        var result = this.$c.defer<T>();
        jQ.done(r => {
            try {
                resolveToError(r, true);
                result.resolve(r);
            } catch (err) {
                result.reject(err);
            }
        });
        jQ.fail(err => result.reject(err));
        return result.promise;
    }

    /** Utility Promise to be resolved after some time */
    Wait(milliSeconds: number) {
        var result = this.$c.defer();
        window.setTimeout(() => result.resolve(), milliSeconds);
        return result.promise;
    }

    /** Repeat Reolving a Promise from Factory until it returns a value (!== undefined) for max amount of times */
    WaitUntil<T>(p: () => PromiseLike<T>, maxCount: number, waitSecs: number = 0): PromiseLike<T> {
        return p().then(s => waitSecs > 0 && this.Wait(waitSecs).then(() => s)).then((succ) => {
            if (succ !== undefined || !(maxCount > 0))
                return succ;

            return this.WaitUntil(p, maxCount - 1, waitSecs);
        });
    }
}

class CtrAdminGlobalSettings {
    static $inject = ["$scope", "DialogService", "RwfAppSettings", "$controller"];
    constructor($scope: ng.IScope, dlg: DialogService, rwfAppSettings: RwfAppSettings, $controller: ng.IControllerService) {
        var settings = $scope["GSettings"] = {
            Loaded: false,
            Config: <IRwfApplicationSettings>null,
            SaveLookupConfig: {
                Execute: () => {
                    return rwfAppSettings.Get().then(c => {
                        c.LookupSettings = settings.Config.LookupSettings;
                        return rwfAppSettings.Save(c).then(reload, reload);
                    });
                }
            },

            SaveFormSettings: {
                Execute: () => {
                    return rwfAppSettings.Get().then(c => {
                        c.FormSettings = settings.Config.FormSettings;
                        return rwfAppSettings.Save(c).then(reload, reload);
                    });
                }
            },

            EditCustomizations: {
                Execute: () => {
                    var $cScope = $scope.$new();
                    var ctrl = <KWFMetaDataAdminController>$controller("KWFMetaDataAdminController", { $scope: $cScope });
                    return ctrl.Init.then(() => {
                        return ctrl["Actions"]["ReduceAllCustomizations"].Execute();
                    });

                    //return dlg.ShowWindow({
                    //    windowOptions: {
                    //        modal: true,
                    //        actions: ["Maximize", "Close"]
                    //    },
                    //    controller: "KWFMetaDataAdminController",
                    //    templateUrl: "/fragments/adminProperties.fragment.html"
                    //});
                }
            }
        };

        function reload() {
            rwfAppSettings.Get().then(config => {
                const s = config.FormSettings = config.FormSettings || { };
                s.SaveTemp = s.SaveTemp || {};
                config.FormSettings = config.FormSettings;
                settings.Config = config;
                settings.Loaded = true;
            });
        }
        reload();
    }
}

var PagePropertyEdit = Model.define({
    id: "Name",
    fields: [
        { type: "string", field: "Name", editable: false },
        { type: "string", field: "Title" },
        { type: "boolean", field: "AutoUpdate", nullable: true },
    ]
});
//var PagePropertyEditFields = fn.DictToArray(PagePropertyEdit.fields).map(item => item.field);

class KWFMetaDataAdminController extends Observable {
    static $inject = ["$scope", "$q", "$http", "DialogService", "KWFApplication", "NavPageAdminService"];
    constructor($scope: ng.IScope, $q: ng.IQService, private $http: ng.IHttpService, dlg: DialogService, private kwfApp: KWFApplicationService, private kwfAdmin: NavPageAdminService) {
        super();
        var me = $scope["Meta"] = this;
        var refresh = me.Refresh = fn.proxy(me.Refresh, me);
        var getSelected = me.GetSelected = fn.proxy(me.GetSelected, me);
        var safeCustomization = (p: IPageMetaData) => kwfAdmin.SavePageCustomization(p).then(refresh);

        // Setup Actions to Bind to UI
        var actions = this["Actions"] = {
            "SaveCurrent": {
                Enabled: false,
                Execute: () => {
                    var props = me.CurrEdit.Properties.map((item: any) => <IPageProperty><any>(item.toJSON()));
                    var data = <IPageMetaData>JSON.parse(JSON.stringify(me.CurrEdit.Current));
                    data.Properties = props;
                    return safeCustomization(data);
                }
            },
            "DeleteCustomization": {
                Enabled: false,
                Execute: () => dlg.WhenConfirm("Anpassungen wirklich löschen?").then(() => safeCustomization(me.CurrEdit.Current.Static.Data))
            },
            "ReduceAllCustomizations": {
                Enabled: true,
                Execute: () => {
                    var infos = this.MetaInfos;
                    var toReduce = infos.filter(item => item.Custom && item.Custom.HasData);
                    if (toReduce.length == 0)
                        return dlg.ShowError("Keine Metadatenanpassungen gefunden.");
                    var dialogState: IDialogState;

                    // Controller for reducing Customizations
                    class ReduceDlgController {
                        static $inject = ["$scope", "$http"];
                        constructor($dialogScope: ng.IScope, $http: ng.IHttpService) {
                            var state = $dialogScope["state"] = {
                                CurrentPage: "...",
                                Aktion: "Starten",
                                Pages: toReduce.map(item => { return { PageName: item.Key, Execute: true, Data: item }; }),
                                // Execute Reduce Action
                                Execute: () => {
                                    //state.Aktion = "Abbrechen";
                                    var start = state.Pages.reduce((p, c) => {
                                        return p.then(() => {
                                            if (!c.Execute)
                                                return;
                                            var pageName = state.CurrentPage = c.PageName;
                                            var result = kwfAdmin.CleanupCustomization({ pageName: pageName }).then(fn.noop, err => {
                                                return dlg.WhenConfirm(`Fehler bei der Bearbeitung von '${c.PageName}(${c.Data.Custom.Error || ""})': :\n${resolveToError(err)}\n\n Fortfahren?`);
                                            });

                                            return result;
                                        });
                                    }, $q.when(<any>null));

                                    start.finally(() => {
                                        dialogState.window.close();
                                        me.ReloadMetaInfos();
                                    });

                                    return start;
                                }
                            };
                        }
                    };

                    return dlg.ShowWindow({
                        controller: ReduceDlgController,
                        windowOptions: {
                            modal: true
                        },
                        template: `
<div>Es wurden folgenden kundenspezifischen Anapssungen gefunden, wählen sie die zu reduzierenden aus:</div>
<div ng-repeat='item in state.Pages'>
    <input type='checkbox' ng-model='item.Execute'></input>{{item.PageName}}<br />
</div>
<div><button class='k-button' ng-click='state.Execute()'>{{state.Aktion}}</button></div>`,
                    }).then(s => {

                        return (dialogState = s).close;
                    });

                }
            }
        };

        me.bind("SelectedPageChanged", () => {
            actions.SaveCurrent.Enabled = false;
            actions.DeleteCustomization.Enabled = me.Selected && me.Selected.Custom.HasData;
        });

        this["PropPageDDOptions"] = <kendo.ui.DropDownListOptions>{
            dataSource: this.MetaInfos, dataTextField: 'Key', dataValueField: 'Key',
            template: "<div title='{{dataItem.Static.Error}}' ng-class='{ \"k-changed\" : dataItem.Custom.HasData,  \"k-error\" : !!dataItem.Static.Error }' >{{dataItem.Key}}<div>",
            valueTemplate: "<div ng-class='{ \"k-changed\" : Meta.Selected.Custom.HasData, \"k-error\" : !!Meta.Selected.Static.Error  }' >{{dataItem.Key}}<div>" // via Selected : implicit refresh on Save
        };
        this["PropGridOptions"] = kutils.UpdateGridOptions(<NavGridOptions>{
            dataSource: kutils.GetGridDataSource(this.CurrEdit.Properties),
            columns: [
                {
                    field: "_HasChanges", width: "50px", title: "Geändert", editable: false,
                    template: "<div style='overflow: hidden'>" +
                        "<span class='k-icon' ng-class='{ \"k-denied\" : dataItem.ReadOnly === true, \"k-edit\" : dataItem.ReadOnly !== true }'></span>" +
                        "<button class='k-button' title='auf Standard zurücksetzen' inf-operation='dataItem._Actions.Reset' ><span class='k-icon k-i-funnel'></span>X</button></div>"
                },
                { field: "Name", width: "200px" },
                { field: "Title", title: "Titel", width: "300px", template: "<div ng-class='{ \"k-changed\" : dataItem.TitleChanged  }'>{{dataItem.Title}}<div>" },
                { field: "AutoUpdate", title: "automat. Update", width: "150px", template: "<div ng-class='{ \"k-changed\" : dataItem.AutoUpdateChanged  }'>{{dataItem.AutoUpdate}}<div>" },
            ],
            beforeEdit: (e) => {
                if (e.field == "AutoUpdate" && e.model.ReadOnly == true)
                    e.preventDefault();
            },
            sortable: true, groupable: false, selectable: "row", columnMenu: true, editable: true, reorderable: true, filterable: "row", pageable: true,
        });

        var _props = ["Title", "AutoUpdate"];
        $scope.$watch(getSelected, pInfo => {
            var custom = pInfo && pInfo.Custom;
            var staticProps = (pInfo && pInfo.Static.Data.Properties) || [];
            var customProps = (custom && custom.CustomData && custom.CustomData.Properties) || [];

            var editProps = fn.OuterJoin(staticProps, customProps, item => item.Name, (sProp, cProp) => {
                var actReset = {
                    Enabled: false,
                    Execute: () => {
                        _props.forEach(p => result.set(p, sProp[p]));
                        result.dirty = false;
                    }
                };
                var result = new PagePropertyEdit($.extend({
                    _Actions: {
                        Reset: actReset
                    },
                }, cProp || sProp));
                var onChange = () => {
                    _props.forEach(prop => { result[prop + "Changed"] = (result[prop] !== sProp[prop]); });
                    actReset.Enabled = result["_HasChanges"] = !_props.every(p => result[p] === sProp[p]);
                };
                onChange();
                result.bind("change", () => {
                    actions.SaveCurrent.Enabled = true;
                    onChange();
                    if (!$scope.$$phase)
                        $scope.$apply();
                });
                // Outer View is still a IPageProperty Item
                return <IPageProperty><any>result;
            });
            // Refresh Edit Props Container from Page
            var props = me.CurrEdit.Properties;
            props.splice(0, props.length, ...editProps);
            me.CurrEdit.Current = pInfo;
            me.trigger("SelectedPageChanged");
        });

        this.Init = UISafe(this.ReloadMetaInfos());
    }

    public Init: PromiseLike<void>;

    public GetSelected() { return !!(this.Selected && this.Selected.Key) && this.Selected; }
    /** Selected Info from Server */
    public Selected: INavPageInfo;

    /** Current Edit Page Information */
    public CurrEdit = {
        Current: <INavPageInfo>undefined,
        Properties: kutils.AsObservableArray(new Array<IPageProperty>()),
    };

    public MetaInfos = kutils.AsObservableArray<INavPageInfo>();
    /** Reload Current State from Server */
    public ReloadMetaInfos() {
        return this.kwfAdmin.GetAvailablePageInfos().then(pageInfos => {

            return this.kwfAdmin.GetViewConfiguration().then(v => {
                var mainPages = fn.DictToArray(v.Pages).map(p => p.PageName);
                mainPages.push(FDRW_WFInstance, rwf3.Pages.FDRW_WFInstanceCompleted.PageName);
                // Sort Retrieved Page Informations Page Informations
                pageInfos = pageInfos.sort((a, b) => (mainPages.indexOf(b.PageName) - mainPages.indexOf(a.PageName)) || (a.Key.localeCompare(b.Key)));
                var newData = <any>(new ObservableArray(pageInfos));
                kutils.ReplaceObservableData(this.MetaInfos, newData, d => d.Key);
                this.Selected = this.Selected || newData[0];
            });
        });
    }

    /** Refresh State from Server */
    Refresh() {
        var selKey = this.Selected && this.Selected.Key;
        return this.ReloadMetaInfos().then(() => {
            if (selKey)
                this.Selected = this.MetaInfos.filter(item => item.Key == selKey)[0];
        });
    }
}

angular.module("KWF.Admin", ["KWF.Services"])
    .controller("KWFAdminController", KWFAdminController)
    .controller("KWFJobQueueController", KWFJobQueueController)
    .controller("ViewAdminController", ViewAdminController)
    .controller("KWFAppUpdateController", KWFAppUpdateController)
    .controller("KWFMetaDataAdminController", KWFMetaDataAdminController)
    .controller("CtrAdminGlobalSettings", CtrAdminGlobalSettings)
    .service("KWFAdminService", KWFAdminService);
;
